import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import style from './header.scss';

@customElement('cdx-header')
export class Header extends LitElement {
  static get styles() {
    return style;
  }

  @property() openExternalLink = false;

  protected render() {
    return html`
      <header class="cdx-header">
        <div class="cdx-header__global-bar">
          <div class="cdx-header__logo--clarivate">
            <svg width="110" height="20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M81.412 7.198c2.232 0 4.271 1.03 4.271 3.627v6.46h-2.79v-.923a3.313 3.313 0 0 1-2.747 1.18 3.222 3.222 0 0 1-3.434-3.09c0-1.867 1.373-3.026 3.563-3.026h1.931c.472 0 .687-.215.687-.58v-.107c0-.708-.558-1.159-1.631-1.159a6.681 6.681 0 0 0-2.962.923L77.205 8.4a8.412 8.412 0 0 1 4.207-1.202Zm-33.697 0c2.232 0 4.27 1.03 4.27 3.627v6.46h-2.79v-.923a3.313 3.313 0 0 1-2.746 1.18 3.222 3.222 0 0 1-3.434-3.09c0-1.867 1.373-3.026 3.562-3.026h1.932c.472 0 .687-.215.687-.58v-.107c0-.708-.558-1.159-1.631-1.159a6.68 6.68 0 0 0-2.962.923L43.508 8.4a8.413 8.413 0 0 1 4.207-1.202Zm-17.88-5.194a7.387 7.387 0 0 1 7.362 5.601h-3.283a4.043 4.043 0 0 0-4.078-2.854c-2.833 0-4.722 2.146-4.722 5.022 0 2.876 1.889 5.022 4.722 5.022a4.043 4.043 0 0 0 4.078-2.854h3.283a7.387 7.387 0 0 1-7.361 5.602 7.598 7.598 0 0 1-7.834-7.77 7.598 7.598 0 0 1 7.834-7.77Zm69.349 5.194c2.704 0 5.15 1.76 5.15 5.88v.108h-7.318a2.334 2.334 0 0 0 4.228.965l2.897.301a5.269 5.269 0 0 1-10.065-2.082 4.979 4.979 0 0 1 5.108-5.172ZM91.07 3.72v3.734h2.124v2.361H91.07v4.443c0 .622.493.708.922.708.709 0 1.288-.064 1.288-.064v2.382s-1.352.129-2.168.129c-1.395 0-2.833-.236-2.833-2.21V9.815h-1.545v-2.36h1.545V3.72h2.79ZM69.307 7.455l2.103 6.825 2.232-6.825h2.94l-3.498 9.83H69.63l-3.348-9.83h3.026Zm-4.164 0v9.83h-2.79V9.816h-1.374v-2.36h4.164Zm-6.246-.129c.26-.003.52.026.773.086v2.79h-1.18c-1.417 0-2.061.666-2.061 2.383v4.7h-2.79v-9.83h2.704v1.567a2.589 2.589 0 0 1 2.554-1.696ZM41.512 2.261v15.024h-2.769V2.261h2.769Zm41.381 10.796a1.213 1.213 0 0 1-.859.214h-1.051c-.88 0-1.395.387-1.395 1.074 0 .665.536 1.159 1.395 1.159a1.7 1.7 0 0 0 1.91-1.739v-.708Zm-33.697 0a1.213 1.213 0 0 1-.859.214h-1.051c-.88 0-1.395.387-1.395 1.074 0 .665.536 1.159 1.395 1.159a1.7 1.7 0 0 0 1.91-1.739v-.708Zm49.988-3.541a2.192 2.192 0 0 0-2.233 1.802h4.4a2.132 2.132 0 0 0-2.167-1.802ZM63.619 2.26a1.8 1.8 0 0 1 1.803 1.803 1.792 1.792 0 1 1-1.803-1.803Zm-48.932 8.12a15.637 15.637 0 0 1 2.339 3.826 19.88 19.88 0 0 1-9.602 5.55 15.508 15.508 0 0 1-2.152-3.933 15.618 15.618 0 0 0 9.415-5.444ZM.79 4.83c1.49-.18 2.999-.145 4.479.105-.17.457-.32.924-.447 1.4-.848 3.132-.69 6.45.45 9.488-1.482.25-2.992.285-4.484.105A19.879 19.879 0 0 1 .791 4.83ZM7.413 1c3.666.9 7 2.827 9.613 5.553a15.637 15.637 0 0 1-2.34 3.826A15.618 15.618 0 0 0 5.27 4.935 15.512 15.512 0 0 1 7.413 1Z"
              />
            </svg>
          </div>
          <slot name="cdx-header-global"></slot>
        </div>
        <div class="cdx-header__product-bar">
          <div class="cdx-header__product-identification">
            <slot name="cdx-header-product-logo"></slot>
            <slot name="cdx-header-product-name"></slot>
          </div>
          <slot></slot>
        </div>
      </header>
    `;
  }

  firstUpdated() {
    const slots = this.shadowRoot.querySelectorAll('slot');
    slots.forEach((slot) => {
      if (slot.assignedNodes().length === 0) {
        this.toRemove(slot);
      }
    });

    const productIdentification = this.shadowRoot.querySelector(
      '.cdx-header__product-identification',
    );
    if (!productIdentification.children.length) {
      this.toRemove(productIdentification);
    }

    const logoElement = this.shadowRoot.querySelector(
      '.cdx-header__logo--clarivate',
    );
    logoElement.addEventListener('click', () => {
      window.open(
        'http://www.clarivate.com',
        this.openExternalLink ? '_blank' : '_self',
      );
    });
  }

  private toRemove(element: Element) {
    const parent = element.parentElement;
    parent.removeChild(element);
    if (parent.innerHTML.trim() == '') {
      parent.innerHTML = parent.innerHTML.trim();
    }
  }
}
